import { Case, Group, User } from '@mi-front/core';
import { MinimumStation } from '@app/core/types/stations';

export enum UserPermissionSource {
  FROM_ROLE = 'FROM_ROLE',
  DIRECT = 'DIRECT',
  FROM_GROUP = 'FROM_GROUP',
  DIRECT_AND_FROM_GROUP = 'DIRECT_AND_FROM_GROUP',
}

export type UserPermissionType =
  // permission from (e.g. CLIENT_ADMIN)
  | Case<UserPermissionSource.FROM_ROLE>

  // direct assignment: station <--> user
  | Case<
      UserPermissionSource.DIRECT,
      // eslint-disable-next-line @typescript-eslint/no-empty-object-type
      {
        // profile: ...
      }
    >

  // indirect assignment: station <--> group <-- user
  | Case<
      UserPermissionSource.FROM_GROUP,
      {
        group: Group;
        // profile: ...
      }
    >

  // both direct and indirect assignment
  | Case<
      UserPermissionSource.DIRECT_AND_FROM_GROUP,
      {
        group: Group;
        // profile: ...
        // groupProfile: ...
      }
    >;

export enum GroupPermissionSource {
  DIRECT = 'DIRECT',
}

export type GroupPermissionType = {
  // direct assignment: station <--> group
  type: GroupPermissionSource.DIRECT;
  // profile: ...
};

export interface PermissionState {
  readonly permission: null | {
    type: any;
  };
}

export interface UserPermissionState extends PermissionState {
  readonly user: User;
  readonly permission: null | UserPermissionType;
}

export interface GroupPermissionState extends PermissionState {
  readonly group: Group;
  readonly permission: null | GroupPermissionType;
}

export interface UserPermissionForStationState {
  readonly station: MinimumStation;
  readonly permission: null | UserPermissionType;
}

export interface GroupPermissionForStationState {
  readonly station: MinimumStation;
  readonly permission: null | GroupPermissionType;
}

/**
 * API payloads
 */

export interface UserPermissionUpdate {
  readonly userId: User['id'];
  readonly allowed: boolean;
}

export interface GroupPermissionUpdate {
  readonly groupId: Group['id'];
  readonly allowed: boolean;
}
